import React, { useState } from "react";
import CommonDataTable from "../../../components/ui/table/CommonTable";
import { useGetMealItemsQuery } from "../../../featureSlice/mealItemSliceApi";
import EditIcon from "../../../svg/EditIcon";
import DeleteIcon from "../../../svg/DeleteIcon";

const MealItemTable = ({ onEditClick, onDeleteClick }) => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const { data } = useGetMealItemsQuery({
    page,
    limit: rowsPerPage,
  });

  const columns = [
    { name: "Meal Item ID", selector: (row) => row?.meal_item_id },
    { name: "Meal Item Name", selector: (row) => row?.meal_item_name },
    {
      name: "Veg/Non Veg ",
      cell: (row) => (
        <span
          className={`text-xs px-3 ml-2 py-1.5 rounded font-medium  ${
            row?.meal_item_is_veg
              ? "bg-green-100 text-green-600 border border-green-500"
              : "bg-red-100 text-red-600 border border-red-500"
          }`}
        >
          {row?.meal_item_is_veg ? "Veg" : "Non-Veg"}
        </span>
      ),
    },
    {
      name: "Status",
      cell: (row) => (
        <span
          className={`text-xs px-2 py-1.5 rounded font-medium ${
            row?.meal_item_status
              ? "bg-green-100 text-green-600 border border-green-500"
              : "bg-red-100 text-red-600 border border-red-500"
          }`}
        >
          {row?.meal_item_status ? "Active" : "Inactive"}
        </span>
      ),
    },

    {
      name: "Action",
      cell: (row) => (
        <div className="flex gap-3 items-center justify-start">
          <button
            onClick={() => {
              onEditClick(row);
            }}
          >
            <EditIcon />
          </button>

          <button
            className="p-2"
            onClick={(e) => {
              onDeleteClick(row?.id);
            }}
          >
            <DeleteIcon />
          </button>
        </div>
      ),
    },
  ];

  const rows = data?.data || [];

  return (
    <div>
      <CommonDataTable
        columns={columns}
        data={rows}
        pagination
        paginationServer
        paginationTotalRows={data?.meta_data?.total_records || 0}
        onChangePage={(page) => setPage(page)}
        onChangeRowsPerPage={(newLimit) => {
          setRowsPerPage(newLimit);
          setPage(1);
        }}
      />
    </div>
  );
};

export default MealItemTable;
